import { District } from "./District";

export class Country {
  constructor(name, code, codename, divisionType, phoneCode, districts) {
    this.name = name;
    this.code = code;
    this.codename = codename;
    this.divisionType = divisionType;
    this.phoneCode = phoneCode;
    this.districts = districts;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new Country(
        input.n,
        input.c,
        input.cn,
        input.dt,
        input.pc,
        District.fromApiArray(input.d),
      )
    }
    return new Country();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => Country.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [Country.fromApiObject(input)];
    }

    return [];
  }

  static getCountryList() {
    return Country.fromApiArray(window.VNCountry);
  }

  static getCountry(listCountry = [], value, key = "name") {
    if (!listCountry || listCountry.length === 0) {
      return {};
    }
    let result = listCountry.find(item => item[key].toLowerCase() === String(value).toLowerCase());
    return result || {};
  }

  static isAllCountry(country) {
    return country === Country.ALL_COUNTRY.value;
  }

  static ALL_COUNTRY = { "value": "all", label: $.i18n("sites_allCountry") };
}